import styled from 'foundations-theming/utils';
import { SENDER_MEETINGS_LINK_TOKEN, MEETING_LINK_DOMAINS } from 'hubspot-prosemirror/draft-transplant/utils/constants';
import { CALYPSO, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useCallback, useMemo, useState } from 'react';
import MeetingsNotYoursTooltip from './MeetingsNotYoursTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const getIsYourMeetingLink = (meetingLinks, meetingURL) => {
  const linkSlug = MEETING_LINK_DOMAINS.reduce((fullUrl, domain) => {
    return fullUrl.indexOf(domain) !== -1 ? fullUrl.replace(domain, '') : fullUrl;
  }, meetingURL);
  const currentLink = meetingLinks.find(link => link.slug === linkSlug);
  return currentLink && currentLink.link === meetingURL;
};
const DEFAULT_BACKGROUND_COLOR = CALYPSO_LIGHT;
const DEFAULT_BORDER_COLOR = CALYPSO_LIGHT;
const DEFAULT_FONT_COLOR = CALYPSO;
const StyledToken = styled.span.withConfig({
  displayName: "MeetingLink__StyledToken",
  componentId: "sc-1bol2ps-0"
})(["background-color:", ";border:1px solid ", ";border-radius:2px;color:", ";cursor:default;display:inline;line-height:1;margin:0;padding:4px 8px;vertical-align:middle;user-select:text;width:auto;"], DEFAULT_BACKGROUND_COLOR, DEFAULT_BORDER_COLOR, DEFAULT_FONT_COLOR);

// if the link was styled to a different color, we will override the default link color with it
const StyledLink = styled.span.withConfig({
  displayName: "MeetingLink__StyledLink",
  componentId: "sc-1bol2ps-1"
})(["color:", ";font-weight:600;text-decoration:none;cursor:pointer;&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.color['do-not-use-calypso-dark']);
const MeetingLink = ({
  meetingName,
  meetingURL,
  meetingLinks,
  hasFetchMeetingDone,
  onClick
}) => {
  const [isLongformOpen, setIsLongformOpen] = useState(false);
  const handleClose = useCallback(() => {
    setIsLongformOpen(false);
  }, []);
  const toggleLongform = useCallback(() => {
    setIsLongformOpen(prevIsLongformOpen => !prevIsLongformOpen);
  }, []);
  const isYourMeetingLink = useMemo(() => getIsYourMeetingLink(meetingLinks, meetingURL), [meetingLinks, meetingURL]);
  if (meetingName === SENDER_MEETINGS_LINK_TOKEN) {
    return /*#__PURE__*/_jsx(StyledToken, {
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.sendermeetingslink"
      })
    });
  }
  if (meetingURL === SENDER_MEETINGS_LINK_TOKEN) {
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.meetings.sendermeetingslink"
      }),
      children: /*#__PURE__*/_jsx(StyledLink, {
        onClick: onClick,
        children: meetingName
      })
    });
  }
  if (hasFetchMeetingDone && !isYourMeetingLink) {
    return /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      open: isLongformOpen,
      placement: "bottom",
      title: /*#__PURE__*/_jsx(MeetingsNotYoursTooltip, {
        meetingURL: meetingURL
      }),
      onClose: handleClose,
      maxWidth: 400,
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.meetings.meetingsLinkNotYours"
        }),
        defaultOpen: true,
        disabled: isLongformOpen,
        children: /*#__PURE__*/_jsx(StyledLink, {
          onClick: toggleLongform,
          children: meetingName
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.meetings.custommeetingslink"
    }),
    children: /*#__PURE__*/_jsx(StyledLink, {
      onClick: onClick,
      children: meetingName
    })
  });
};
export default MeetingLink;